import { replace } from "ramda"

export const parameterByName = (name, url = window.location.href) => {
  const regex = new RegExp("[?&]" + replace(/[\[\]]/g, "\\$&", name) + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url)

  if (!results) return null
  if (!results[2]) return ""
  return decodeURIComponent(replace(/\+/g, " ", results[2]))
}
